// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"78":"9955a2fd","150":"5a93df0f","198":"3be84f82","227":"350ab284","488":"29b71886","508":"881e1738","735":"5353191f"}[chunkId] + ".chunk.js";
};